import colors from "../base/colors";
import typography from "../base/typography";

const { grey } = colors;
const { size } = typography;

const breadcrumbs = {
  styleOverrides: {
    li: {
      lineHeight: 0,
    },

    separator: {
      fontSize: size.sm,
      color: colors.white.main,
    },

    // Link stilleri için
    "& a": {
      textDecoration: 'none',
      color: 'inherit',
      '&:hover': {
        textDecoration: 'none',
        color: 'inherit'
      },
      '&:visited': {
        color: 'inherit'
      },
      '&:focus': {
        color: 'inherit'
      }
    }
  },
};

export default breadcrumbs;
